import createInstanceFactory from './create-instance';
import allNames from './utils/all-names';
import assertExists from './utils/assert-exists';
import mapObject from './utils/map-object';
const $INSTANCES = Symbol('TRUE-DI::INSTANCES');
const itemsOf = (container) => assertExists(container[$INSTANCES], 'Argument is not a container');
export const isReady = (container, name) => itemsOf(container).has(name);
export const prepareAll = (container) => mapObject(container, name => container[name]);
export const releaseAll = (container) => {
    itemsOf(container).clear();
};
export const factoriesFrom = (container, names) => mapObject(container, name => () => container[name], names);
function diContainer(factories) {
    const instances = new Map();
    const createInstance = createInstanceFactory(factories, instances);
    const container = allNames(factories).reduce((containerObj, name) => Object.defineProperty(containerObj, name, {
        configurable: false,
        enumerable: Object.getOwnPropertyDescriptor(factories, name).enumerable,
        get: () => createInstance(container, name),
        set: (value) => {
            if (value != null) {
                throw new Error('Container does\'t allow to replace items');
            }
            instances.delete(name);
        },
    }), Object.create(Object.create(null, {
        [$INSTANCES]: {
            configurable: false, writable: false, enumerable: false, value: instances,
        },
    })));
    return container;
}
export default diContainer;
